var map = {
	"./about-us.json": 4890,
	"./add-ons.json": 986,
	"./blog-thumbs.json": 4860,
	"./blog.json": 810,
	"./blog__are-you-really-profitable-on-swiggy-zomato-understanding-commissions-costs-real-margins.json": 5435,
	"./blog__best-cloud-kitchen-location-bangalore.json": 1257,
	"./blog__cloud-kitchen-benefits-for-food-entrepreneurs.json": 2629,
	"./blog__cloud-kitchen-business-model.json": 6733,
	"./blog__cloud-kitchen-faqs.json": 3742,
	"./blog__cloud-kitchen-franchise-in-bangalore.json": 2126,
	"./blog__cloud-kitchen-franchising-vs-kitchen-as-a-service.json": 9625,
	"./blog__cloud-kitchen-near-me-bangalore.json": 5486,
	"./blog__cloud-kitchen-setup-cost.json": 7618,
	"./blog__cloud-kitchen-startup-checklist.json": 5529,
	"./blog__cloud-kitchen-success-stories-skope-kitchens.json": 2467,
	"./blog__cloud-kitchen-vs-restaurant-business.json": 7749,
	"./blog__expanding-your-cloud-kitchen-without-selling-franchises-the-complete-guide.json": 9959,
	"./blog__food-entrepreneur-skills.json": 3925,
	"./blog__ghost-kitchen-vs-cloud-kitchen.json": 7103,
	"./blog__how-many-employees-does-it-take-to-run-a-restaurant.json": 6398,
	"./blog__how-much-money-can-restaurants-make.json": 2496,
	"./blog__how-to-grow-your-cloud-kitchen-business.json": 8762,
	"./blog__how-to-order-food-online.json": 4044,
	"./blog__how-to-start-a-cloud-kitchen-in-india.json": 8048,
	"./blog__how-to-start-a-food-business-from-home.json": 2354,
	"./blog__how-to-start-a-meal-prep-business.json": 4868,
	"./blog__how-to-start-a-restaurant-with-little-to-no-money.json": 372,
	"./blog__how-to-start-bakery-business-from-home.json": 1400,
	"./blog__inventory-tracking-system.json": 9708,
	"./blog__kitchen-as-a-service.json": 7107,
	"./blog__ordering-food-online-for-delivery.json": 1870,
	"./blog__restaurant-franchising-guide.json": 5239,
	"./blog__restaurant-loyalty-program-guide.json": 5228,
	"./blog__restaurant-management-software.json": 2405,
	"./blog__restaurant-marketing-guide.json": 4495,
	"./blog__stuck-at-one-cloud-kitchen-location-how-to-scale.json": 94,
	"./blog__takeaway-restaurants-near-me-bangalore.json": 5406,
	"./blog__the-unit-economics-of-a-cloud-kitchen.json": 9872,
	"./blog__tips-for-properly-managing-food-costs.json": 3999,
	"./blog__top-restaurant-trends-in-india.json": 6146,
	"./blog__underutilized-restaurant-space-cloud-kitchen.json": 6726,
	"./blog__what-is-a-cloud-kitchen.json": 8438,
	"./blog__what-licenses-and-permits-do-you-need-to-start-a-restaurant.json": 4132,
	"./blog__why-cloud-kitchens-struggle-to-scale-beyond-aggregators.json": 5728,
	"./blog__your-restaurant-isn-t-profitable-here-s-how-to-turn-it-into-a-revenue-generating-cloud-kitchen.json": 4842,
	"./blog__zero-capex-cloud-kitchen-expansion-how-it-works-in-india.json": 2517,
	"./careers.json": 5113,
	"./cooking-up-success.json": 1930,
	"./faq.json": 4826,
	"./for-brands.json": 7150,
	"./for-restaurants.json": 1156,
	"./home.json": 7837,
	"./how-do-we-help-you.json": 2133,
	"./index.json": 5878,
	"./our-brands__al-mashawi-shawarma.json": 1176,
	"./our-brands__chaatgpt.json": 5451,
	"./our-brands__chicbun.json": 9797,
	"./our-brands__kritunga-biryani.json": 2727,
	"./our-brands__saladeo.json": 4676,
	"./our-brands__skope-cafe.json": 5913,
	"./schedule-a-call.json": 9572,
	"./terms-con.json": 4612,
	"./terms-text.json": 7239
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9059;